import { BillingListItem } from '@reveni-io/reveni-ui'

import NoResultsFound from '@/common/components/NoResultsFound/NoResultsFound'
import { openInNewTab } from '@/common/helpers/helpers'

const BillingReportsList = ({ reports, onSelectInvoice }) => {
  if (!reports?.length) {
    return <NoResultsFound />
  }

  return reports.map(invoice => (
    <BillingListItem
      key={invoice.number}
      invoice={invoice}
      currency={invoice?.total_amount_currency}
      onDownload={() => openInNewTab(invoice?.billing_report_file_url)}
      onOpen={() => openInNewTab(invoice?.invoice_file_url)}
      onSelectInvoice={onSelectInvoice}
    />
  ))
}

export default BillingReportsList
